import React, { lazy, Suspense , useState, useEffect } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./views/pages/chatbot-main"
import NetworkDetector from './networkHandler';
import axios from 'axios'
import { setCookie,updateCookie } from "./views/utility/cookies";
import { btoa, atob } from './cryptographic/crypto';
const api = process.env.REACT_APP_API_CHAT_BASE_URL
// if (`${process.env.NODE_ENV}` === "production") {
	console.log = function () { };
	// 	console.dir = function () { };
// }

function App({props,stateObj}) {
	const[botInfo, setBotInfo]=useState([])
	const [fMessages, setFMessages] = useState([
        {title : "Message Here"},
    ])
	const [botLang, setBotLang] = useState(false)
	const [widgetStyle, setWidgetStyle] = useState("style2")
	const [loader, setloader] = useState(false)
	
	// $("body").bind('cut copy paste', function(event) {
	// 	event.preventDefault();
	// })

	// const [prefLang, setPrefLang] = useState('')
	// const [isLang, setIsLang] = useState(false)
	const [voiceEnabled,setVoiceEnabled] = useState(true)
	const [langArr, setLangArr] = useState(null)
	const[botCName, setBotCName] = useState()
	useEffect(()=>{
		setloader(true)
		try{
			axios
			.post(`${api}api/1.0.0/getBotInfoEnc`, 
			{data:btoa({group_id: process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : process.env.REACT_APP_GROUPID})}
			).then((responseEnc) => {
				const response = { data : atob(responseEnc?.data.data)}
				const data = response?.data?.appInfo
				const botData = response?.data?.bot
				const root = document.documentElement;
				if(data !== undefined){
					setBotInfo(response);
					if(data?.fCardMessages !== undefined){
						setFMessages(data?.fCardMessages)
					}
					if(data?.fCardDetails !== undefined){
						root?.style.setProperty("--fcard-bg", data?.fCardDetails?.cardBg);
						root?.style.setProperty("--fcard-text", data?.fCardDetails?.cardText);
						root?.style.setProperty("--fcard-inner-bg", data?.fCardDetails?.cardInnerBg);
						root?.style.setProperty("--fcard-inner-text", data?.fCardDetails?.cardInnerText);
					}

					if(data?.actionColorsTest !== undefined){
						if(data?.actionColorsTest?.btnBg !== undefined){
							root?.style.setProperty("--btn-bg", data?.actionColorsTest?.btnBg);
						}
						if(data?.actionColorsTest?.btnColor !== undefined){
							root?.style.setProperty("--btn-color", data?.actionColorsTest?.btnColor);
						}
						if(data?.actionColorsTest?.btnHoverBg !== undefined){
							root?.style.setProperty("--btn-hover-bg", data?.actionColorsTest?.btnHoverBg);
						}
						if(data?.actionColorsTest?.btnHoverColor !== undefined){
							root?.style.setProperty("--btn-hover-color", data?.actionColorsTest?.btnHoverColor);
						}
						if(data?.actionColorsTest?.outlineBtnBg !== undefined){
							root?.style.setProperty("--btn-outline-bg", data?.actionColorsTest?.outlineBtnBg);
						}
						if(data?.actionColorsTest?.outlineBtnColor !== undefined){
							root?.style.setProperty("--btn-outline-color", data?.actionColorsTest?.outlineBtnColor);
						}
					}

					if(data?.widgetTitle !== undefined && data?.widgetTitle !== ""){
						setBotCName(data?.widgetTitle)
					}

					if(response?.data?.mobileAppConfig?.voiceEnable === "N"){
						setVoiceEnabled(false)
					}else{
						setVoiceEnabled(true)
					}

					if(data?.widgetStyle !== undefined && data?.widgetStyle !== ""){
						setWidgetStyle(data?.widgetStyle)
					}
					if(data?.fontFamily === "Josefin_Sans"){
						root?.style.setProperty("--primary-fonts", "Josefin");
					}else if(data?.fontFamily === "Source_Sans_Pro"){
						root?.style.setProperty("--primary-fonts", "'Source Sans Pro', sans-serif");
					}else if(data?.fontFamily === "Roboto"){
						root?.style.setProperty("--primary-fonts", "'Roboto', sans-serif");
					}else{
						root?.style.setProperty("--primary-fonts", 'Mulish');
					}
					
					root?.style.setProperty("--user-bubble-bg", data?.userBBg);
					root?.style.setProperty( "--user-bubble-color", data?.userBColor);

					root?.style.setProperty( "--bot-bubble-bg", data?.botBBg);
					root?.style.setProperty( "--bot-bubble-color", data?.botBColor);

					root?.style.setProperty( "--agent-bubble-bg", data?.agentBBg);
					root?.style.setProperty( "--agent-bubble-color", data?.agentBColor);

					root?.style.setProperty( "--primary-color", data?.cPrimaryColor);
					root?.style.setProperty( "--chat-border-radius", data?.cPrimaryColor);
					root?.style.setProperty( "--header-color", data?.cHeaderText);
					
					data?.headerType === "solid" ?
						root?.style.setProperty("--header-bg-color", data?.cHeaderBg)
					:
					root?.style.setProperty("--header-bg-color", "linear-gradient(to "+ data?.bgPosition +","+ data?.linerBgColor.map((l)=>{return(l.color.color +" "+ l.color.percentage +"%")})+")");

					data?.minimizedOption === "minimize" ?
							root?.style.setProperty("--chat-border-radius", "20px")
						:
							root?.style.setProperty("--chat-border-radius", "0")

					data?.maximizedOption === "rounded" ?
						root?.style.setProperty("--chat-toggle-radius", "50%")
					:
						root?.style.setProperty("--chat-toggle-radius", "4px")
					setloader(false)
				}
				if( botData !== undefined && botData.length > 0){
					setBotLang(true)
					setLangArr(botData)
					console.log("print first this ekktta", botLang)
					console.log("print first this ekktta2", langArr)
				}
				
			});
		}catch(e){
			setloader(false)
			// console.error(e, "api error")
		}
	},[])

	

	return (
		<>
		{
			<LandingPage loader={loader}  properties = {props} stateObj= {stateObj} botInfo={botInfo} fMessages={fMessages} voiceEnabled={voiceEnabled} botCName={botCName} widgetStyle={widgetStyle} />
		} 
		</>
	);
}

export default NetworkDetector(App);

